exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delivery-order-info[data-v-7bdd5e81],.delivery-orderproduct-table[data-v-7bdd5e81]{width:100%}.delivery-orderproduct-table th[data-v-7bdd5e81]{background-color:#eee}.delivery-order-info td[data-v-7bdd5e81],.delivery-orderproduct-table td[data-v-7bdd5e81],.delivery-orderproduct-table th[data-v-7bdd5e81]{text-align:center!important;border:1px solid #e0d9d9;border-bottom-width:thin!important;padding:6px;vertical-align:middle!important}.delivery-orderproduct-table .table-result[data-v-7bdd5e81]{background-color:#ebeae4}.delivery-order-info .order-info-title[data-v-7bdd5e81]{background-color:#eee}", ""]);

// exports
